import { z } from 'zod';

export const WorkflowPerformanceMetricsSchema = z.object({
  tasksCompleted7Days: z.number(),
  tasksCompletedTotal: z.number(),
  averageAccuracy: z.number(),
  averageThroughput: z.number(),
  activeHours7Days: z.number(),
  qualityScoreRange: z.object({
    from: z.number(),
    to: z.number(),
  }),
  specializedMetrics: z.object({
    yawErrorDeg: z.number(),
    classificationErrors: z.number(),
  }),
});

export const GamificationSchema = z.object({
  currentLevel: z.number(),
  totalPoints: z.number(),
  pointsToNextLevel: z.number(),
  badges: z.array(
    z.object({
      name: z.string(),
      description: z.string(),
      earnedDate: z.string(),
      icon: z.string(),
    })
  ),
  achievements: z.array(
    z.object({
      title: z.string(),
      description: z.string(),
      progress: z.number(),
      maxProgress: z.number(),
      reward: z.string(),
    })
  ),
  leaderboardRank: z.union([z.string(), z.number()]),
  percentileRank: z.number(),
});

export const WorkflowPerformanceSchema = z.object({
  performanceMetrics: WorkflowPerformanceMetricsSchema,
  gamification: GamificationSchema,
});
